import * as React from "react";

export const Baseline = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4999 1.3999C2.89239 1.3999 2.3999 1.89239 2.3999 2.4999V5.4999C2.3999 6.10742 2.89239 6.5999 3.4999 6.5999H12.4999C13.1074 6.5999 13.5999 6.10742 13.5999 5.4999V2.4999C13.5999 1.89239 13.1074 1.3999 12.4999 1.3999H3.4999ZM3.5999 5.3999V2.5999H12.3999V5.3999H3.5999ZM3.4999 9.3999C2.89239 9.3999 2.3999 9.89239 2.3999 10.4999V13.4999C2.3999 14.1074 2.89239 14.5999 3.4999 14.5999H12.4999C13.1074 14.5999 13.5999 14.1074 13.5999 13.4999V10.4999C13.5999 9.89239 13.1074 9.3999 12.4999 9.3999H3.4999ZM3.5999 13.3999V10.5999H12.3999V13.3999H3.5999Z"
    />
);
